export enum CrysisType {
  Generalized = 'Generalized',
  Focal = 'Focal'
}
